<template>
  <footer id="footer" class="xxfixed-bottom container">
    <div class="text-white">
      <div class="row text-center my-2">
        <div class="col-12 col-lg-5">
          <a
            tabindex="10"
            href="https://www.ehu.eus/ehusfera/es/"
            title="La blogosfera de la UPV/EHU"
            class="pl-3"
            ><b>ehu</b>sfera</a
          >
          <span class="px-2"> |</span>
          <a
            tabindex="10"
            href="https://www.ehu.eus/es/web/gizartea/ehu-denda"
            title="Tienda de productos de regalo y promoción de la universidad"
            ><b>ehu</b>denda</a
          >
          <span class="px-2">
            <a href="http://www.facebook.com/upv.ehu" tabindex="10">
              <img
                src="@/assets/fb.png"
                alt="La UPV/EHU en Facebook"
                style="width: 20px; margin-right: 10px"
              />
            </a>

            <a href="http://twitter.com/upvehu" tabindex="10">
              <img
                src="@/assets/twitter.png"
                alt="La UPV/EHU en Twitter"
                style="width: 20px; margin-right: 5px; margin-top: 1px"
              />
            </a>
          </span>
        </div>
        <div class="col-12 col-lg-7">
          <a
            tabindex="10"
            href="https://www.ehu.eus/es/contact"
            v-html="$t('footer.contacto')"
          />
          <span class="px-2"> |</span>
          <a
            tabindex="10"
            href="https://www.ehu.eus/es/lege-oharra"
            v-html="$t('footer.infolegal')"
          />
          <span class="px-2"> |</span>
          <a
            tabindex="10"
            href="https://egoitza.ehu.eus/es"
            v-html="$t('footer.sedeelectronica')"
          />
          <span class="px-2"> |</span>
          <a
            tabindex="10"
            href="https://www.ehu.eus/es/laguntza"
            v-html="$t('footer.ayuda')"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String,
  },
};
</script>
<style scoped>
#footer {
  background: #202020 !important;
  text-align: left;
  text-shadow: none;
  overflow: hidden;
  font-family: "ehuSans", "sans-serif";
  font-weight: 400;
  font-size: 80%;
  line-height: 3.5rem;
}

a {
  font-weight: 400;
  color: white !important;
}
</style>
